// extracted by mini-css-extract-plugin
export default {"fieldset":"nrqS_m"};